import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
import { commandLinePackagingInstruction } from "../../Instructions";
import { CommonCommandLineTextForOctopusCliCodeSample, CommonTextForJavaSample, CommonTextForOctopusCli } from "../CommonRegistrationText";
export const CommandLinePackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging Java applications from command line, we recommend using the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>
            .
        </p>
        {CommonTextForJavaSample}
        {CommonTextForOctopusCli}
        {CommonCommandLineTextForOctopusCliCodeSample}
    </div>);
CommandLinePackaging.displayName = "CommandLinePackaging"
export default commandLinePackagingInstruction(() => <CommandLinePackaging />);
